'use strict'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import $ from 'jquery'
import slick from 'slick-carousel'

const video = document.querySelector('video')

export default () => {
  $('.top__mv ul').slick({
    autoplay: true,
    speed: 1500,
    autoplaySpeed: 3000,
    dots: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767
      }
    ]
  })
  $('.top__case__contents__list').slick({
    autoplaySpeed: 1500,
    dots: false,
    slidesToScroll: 1,
    slidesToShow: 3,
    prevArrow:
      '<img src="/assets/images/top/prev.svg" class="slide-arrow prev-arrow">',
    nextArrow:
      '<img src="/assets/images/top/next.svg" class="slide-arrow next-arrow">',
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  })

  video.addEventListener('loadeddata', (event) => {
    document.getElementById('anime01').classList.add('animated')
    document.getElementById('anime02').classList.add('animated')
    video.play()
  })
  video.load()
}
